import React, { useState,useEffect } from 'react';

import axios from 'axios';
import { useParams,useHistory } from "react-router-dom";

import {Configs} from '../api';

const EditTodo =()=> {
    let history= useHistory();
    const id =useParams({})
  const [name, setname] = useState('')
  
const [catLoc, setcatLoc] = useState('')

const [barItems, setItems] = useState([])

  const adddata = async(e) =>{

    try {
    console.log(name,catLoc)
    const result = await axios.post(Configs.ingredients+'/'+id.id,
    {
      name : name,
      itemId :catLoc
    })
    // console.log(result)
     history.push('/dashboard/ingredients')
    
  }
    catch (error) {
      console.log(error.message);
  }
  }


  useEffect(() => {
    const dataID = async() =>{

      try {
      const result = await axios.get(Configs.ingredients+'/'+id.id)
       console.log(result)
      setname(result.data.ingredient.name)
     
     
    }
      catch (error) {
        console.log(error.message);
    }
    }
    const loadLocations= async()=>{
      // console.log(catLoc)
      try {
        const result = await axios.get(Configs.items)
        // console.log(result.data.location)
        setItems(result.data.items)
      }
        catch (error) {
          console.log(error.message);
      }
      }
    
    

    dataID();
    loadLocations();
  },[id.id]);
  
  return ( 

<div className="container-fluid box-styl" >
<h1 className="text-center mt-5">Edit Ingredients</h1>
<form className="d-flex mt-5 mb-5 algnItm "  onSubmit={e=>{adddata(e)}}>
<input type='text' 
          className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
            required
        >
           </input>


        <select id="dropdown" 
        value={barItems._id} 
        className="form-control input-styl"
        onChange={(e)=>setcatLoc(e.target.value)} 
        required
        >
        
        <option value='' >select Items</option>
        {barItems.map((loc)=>(
          
       
          <option key={loc._id} value={loc._id}>{loc.name}</option>
        )
        )
        }
          
        </select>
       
          <button className="btn btn-success">add</button>

</form>
</div>
);
}

    
     
    export default EditTodo;